function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "id-0a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5.722 0 10.944V25h9v-5.167a2.5 2.5 0 0 1 5 0V25h9V10.944L11.5.722z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m0 10.944-.664-.747-.336.298v.45h1zM11.5.722l.664-.747-.664-.59-.664.59.664.747zM0 25h-1v1h1v-1zm9 0v1h1v-1H9zm5 0h-1v1h1v-1zm9 0v1h1v-1h-1zm0-14.056h1v-.449l-.336-.298-.664.747zm-22.336.748 11.5-10.222-1.328-1.495-11.5 10.222 1.328 1.495zM1 25V10.944h-2V25h2zm8-1H0v2h9v-2zm1 1v-5.167H8V25h2zm0-5.167a1.5 1.5 0 0 1 1.5-1.5v-2a3.5 3.5 0 0 0-3.5 3.5h2zm1.5-1.5a1.5 1.5 0 0 1 1.5 1.5h2a3.5 3.5 0 0 0-3.5-3.5v2zm1.5 1.5V25h2v-5.167h-2zM23 24h-9v2h9v-2zm-1-13.056V25h2V10.944h-2zM10.836 1.47l11.5 10.222 1.328-1.495-11.5-10.222-1.328 1.495z",
  fill: "#212121",
  mask: "url(#id-0a)"
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.09522de3.svg";
export { ForwardRef as ReactComponent };